define.alias("shared/helpers/css-safe", "settings/helpers/css-safe");